export const _sigFr = {
    sig: 'Système d\'information géographique',
    home: 'Domicile',
    house: 'Maison',
    appartments: 'Appartements',
    buildings: 'Immeubles',
    transports: 'Transports',
    slowLane: 'Voie lente',
    agglomeration: 'Agglomération',
    fastLane: 'Voie rapide',
    highway: 'Autoroute',
    railwayTrack: 'Voie ferrée',
    seaRoute: 'Voie maritime',
    professionalActivity: 'Activité professionnelle',
    factory: 'Usine',
    warehouse: 'Entrepôt',
    workshop: 'Atelier',
    store: 'Magasin',

    // Types de lieux recevant du public
    publicAccessBuildings: 'Bâtiments recevant du public',
    school: 'École',
    university: 'Université',
    hospital: 'Hôpital',
    clinic: 'Clinique',
    retirementHome: 'Maison de retraite',
    sportsHall: 'Salle de sport',
    stadium: 'Stade',
    swimmingPool: 'Piscine',
    theater: 'Théâtre',
    cinema: 'Cinéma',
    library: 'Bibliothèque',
    museum: 'Musée',
    amusementPark: 'Parc d\'attractions',
    zoo: 'Zoo',
    campground: 'Camping',
    publicPark: 'Parc public',
    indoorMarket: 'Marché couvert',
    publicSquare: 'Place publique',

    // Milieux naturels
    naturalEnvironments: 'Milieux naturel',
    forest: 'Forêt',
    mountain: 'Montagne',
    beach: 'Plage',
    desert: 'Désert',
    river: 'Rivière',
    lake: 'Lac',
    ocean: 'Océan',
    meadow: 'Prairie',
    swamp: 'Marais',
    canyon: 'Canyon',
    cave: 'Grotte',

    // Sites particuliers
    particularSites: 'Sites particulier',
    historicMonument: 'Monument historique',
    archaeologicalSite: 'Site archéologique',
    port: 'Port',
    lighthouse: 'Phare',
    lock: 'Écluse',
    castle: 'Château',
    ruins: 'Ruines',
    dam: 'Barrage',
    bridge: 'Pont',
    waterTreatmentPlant: 'Station d\'épuration',
    quarry: 'Carrière',
    NO_PLACE: 'Non précisé',

    validDepartment: 'Valider le département',
    selectedMapWithSuccess: 'Carte sélectionnée avec succès',
    validMap: 'Choisir cette carte',
    data: 'Données',
    departmentAlreadySelected: 'Département déjà sélectionné',
    addedSuccessfully: 'Département ajouté avec succès',
    deletedSuccessfully: 'Département supprimé avec succès',
    deleteDepartmentConfirm: 'Voulez-vous vraiment supprimer ce département ?',
};

export const _sigEn = {
    sig: 'Geographic Information System',
    home: 'Home',
    house: 'House',
    appartments: 'Apartments',
    buildings: 'Buildings',
    transports: 'Transports',
    slowLane: 'Slow lane',
    agglomeration: 'Agglomeration',
    fastLane: 'Fast lane',
    highway: 'Highway',
    railwayTrack: 'Railway track',
    seaRoute: 'Sea route',
    professionalActivity: 'Professional activity',
    factory: 'Factory',
    warehouse: 'Warehouse',
    workshop: 'Workshop',
    store: 'Store',

    // Types of Public Access Buildings
    publicAccessBuildings: 'Public access building',
    school: 'School',
    university: 'University',
    hospital: 'Hospital',
    clinic: 'Clinic',
    retirementHome: 'Retirement home',
    sportsHall: 'Sports hall',
    stadium: 'Stadium',
    swimmingPool: 'Swimming pool',
    theater: 'Theater',
    cinema: 'Cinema',
    library: 'Library',
    museum: 'Museum',
    amusementPark: 'Amusement park',
    zoo: 'Zoo',
    campground: 'Campground',
    publicPark: 'Public park',
    indoorMarket: 'Indoor market',
    publicSquare: 'Public square',

    // Natural Environments
    naturalEnvironments: 'Natural environments',
    forest: 'Forest',
    mountain: 'Mountain',
    beach: 'Beach',
    desert: 'Desert',
    river: 'River',
    lake: 'Lake',
    ocean: 'Ocean',
    meadow: 'Meadow',
    swamp: 'Swamp',
    canyon: 'Canyon',
    cave: 'Cave',

    // Special Sites
    particularSites: 'Particular sites',
    historicMonument: 'Historic monument',
    archaeologicalSite: 'Archaeological site',
    port: 'Port',
    lighthouse: 'Lighthouse',
    lock: 'Lock',
    castle: 'Castle',
    ruins: 'Ruins',
    dam: 'Dam',
    bridge: 'Bridge',
    waterTreatmentPlant: 'Water treatment plant',
    quarry: 'Quarry',
    NO_PLACE: 'Not specified',

    validDepartment: 'Validate department',
    selectedMapWithSuccess: 'Map selected with success',
    validMap: 'Select this map',
    data: 'Data',
    departmentAlreadySelected: 'Department already selected',
    addedSuccessfully: 'Department added successfully',
    deletedSuccessfully: 'Department deleted successfully',
    deleteDepartmentConfirm: 'Do you really want to delete this department?',
};

export const _sigDe = {
    sig: 'Geoinformationssystem',
    home: 'Zuhause',
    house: 'Haus',
    appartments: 'Wohnungen',
    buildings: 'Gebäude',
    transports: 'Transport',
    slowLane: 'Langsame Spur',
    agglomeration: 'Ballungsraum',
    fastLane: 'Schnelle Spur',
    highway: 'Autobahn',
    railwayTrack: 'Eisenbahngleis',
    seaRoute: 'Seeweg',
    professionalActivity: 'Berufliche Tätigkeit',
    factory: 'Fabrik',
    warehouse: 'Lagerhaus',
    workshop: 'Werkstatt',
    store: 'Geschäft',

    // Types of Public Access Buildings
    publicAccessBuildings: 'Gebäude mit öffentlichem Zugang',
    school: 'Schule',
    university: 'Universität',
    hospital: 'Krankenhaus',
    clinic: 'Klinik',
    retirementHome: 'Altersheim',
    sportsHall: 'Sporthalle',
    stadium: 'Stadion',
    swimmingPool: 'Schwimmbad',
    theater: 'Theater',
    cinema: 'Kino',
    library: 'Bibliothek',
    museum: 'Museum',
    amusementPark: 'Vergnügungspark',
    zoo: 'Zoo',
    campground: 'Campingplatz',
    publicPark: 'Stadtpark',
    indoorMarket: 'Innenmarkt',
    publicSquare: 'Platz',

    // Natural Environments
    naturalEnvironments: 'Natürliche Umgebungen',
    forest: 'Wald',
    mountain: 'Berg',
    beach: 'Strand',
    desert: 'Wüste',
    river: 'Fluss',
    lake: 'See',
    ocean: 'Ozean',
    meadow: 'Wiese',
    swamp: 'Sumpf',
    canyon: 'Schlucht',
    cave: 'Höhle',

    // Special Sites
    particularSites: 'Besondere Orte',
    historicMonument: 'Historisches Denkmal',
    archaeologicalSite: 'Archäologische Stätte',
    port: 'Hafen',
    lighthouse: 'Leuchtturm',
    lock: 'Schleuse',
    castle: 'Schloss',
    ruins: 'Ruinen',
    dam: 'Damm',
    bridge: 'Brücke',
    waterTreatmentPlant: 'Wasserreinigungsanlage',
    quarry: 'Steinbruch',
    NO_PLACE: 'Nicht spezifiziert',

    validDepartment: 'Abteilung validieren',
    selectedMapWithSuccess: 'Karte erfolgreich ausgewählt',
    validMap: 'Wählen Sie diese Karte',
    data: 'Daten',
    departmentAlreadySelected: 'Abteilung bereits ausgewählt',
    addedSuccessfully: 'Abteilung erfolgreich hinzugefügt',
    deletedSuccessfully: 'Abteilung erfolgreich gelöscht',
    deleteDepartmentConfirm: 'Möchten Sie diese Abteilung wirklich löschen?',
};
